export const ProductDesignOutputFieldLabels = {
  title: 'Title',
  essentialRequirements: 'Essential Requirements',
  description: 'Description',
  relatedHazard: 'Mitigation',
  hazardSituation: 'Hazard Situation',
  potentialHarm: 'Potential Harm',
  potentialCauses: 'Potential Cause',
  relevance: 'Relevance',
  currentControls: 'Current Controls',
  residualRisk: 'Residual Risk',
  recommendedActions: 'Recommended Actions',
  actionsTaken: 'Actions Taken',
  verification: 'Verification',
  p1: 'P1',
  s1: 'S2',
  d1: 'D1',
  p2: 'P2',
  s2: 'S2',
  d2: 'D2',
  assignTask: 'Assign Task',
  taskFiles: 'Document References',
  assignDesignInput: 'Assign Design Inputs',
  assignVerification: 'Assign Verifications',
  assignValidation: 'Assign Validations',
  assignDesignSpec: 'Assign Design Spec',
  attachment: 'Attachments',
  components: 'Components',
  release: 'Release'
} as const;

export type ProductDesignOutputField =
  keyof typeof ProductDesignOutputFieldLabels;

export const ProductDesignOutputFields: ProductDesignOutputField[] =
  Object.keys(ProductDesignOutputFieldLabels) as ProductDesignOutputField[];
